/**
 * 定位列表显示字段
 * @type {{Array}
 */
export const locationListColumns = [
    {
        title: '名称',
        slot:'名称',
    },
    {
        title: '坐标ID',
        slot:'坐标ID',
    },
    {
        title: '操作',
        slot:'操作',
        maxWidth: 150,
        align: 'center',
    },
]
